import React, { useContext, createContext } from 'react';

const Context = createContext();

export const Provider = ({state, dispatch, children}) => (
  <Context.Provider value={{ state, dispatch }}>
    {children}
  </Context.Provider>
);

export const getFromContext = () => useContext(Context);
